<template>
  <div>
    <template v-if="show=='文本'">
      <el-input style="width: 100%;" v-model="value1" placeholder="请输入内容"></el-input>
    </template>
    <template v-if="show=='多行文本'">
      <el-input style="width: 100%;" type="textarea" v-model="value1" placeholder="请输入内容"></el-input>
    </template>
    <template v-if="show=='整数'">
      <el-input style="width: 100%;" v-model="value1" v-int></el-input>
      <!-- <el-input-number v-model="value1" v-int :step="1" :min="0"></el-input-number> -->
    </template>
    <template v-if="show=='数字'">
      <el-input style="width: 100%;" v-model="value1" v-num></el-input>
      <!-- <el-input-number v-model="value1" :step="0.1" :min="0"></el-input-number> -->
    </template>
    <template v-if="show=='日期'">
      <el-date-picker
        style="width: 100%;"
        v-model="value1"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
    </template>
    <template v-if="show=='日期+上下午'">
      <el-date-picker
        style="width: 100%;"
        v-model="value1"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="选择日期"
      ></el-date-picker>
      <el-select v-model="value2" clearable>
        <el-option label="上午" :value="0"></el-option>
        <el-option label="下午" :value="1"></el-option>
      </el-select>
    </template>
    <template v-if="show=='日期+时分'">
      <el-date-picker v-model="value1" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
      <el-time-select
        v-model="value2"
        :picker-options="{start: '00:00',step: '00:01',end: '23:59'}"
        placeholder="选择时间"
      ></el-time-select>
    </template>
    <template v-if="show=='下拉框'">
      <el-select
        class="c-select"
        v-model="value1"
        :multiple="multiple"
        @change="onChange"
        clearable
      >
        <template v-for="(i,key) in Options">
          <el-option :key="key" :label="i[KeyLabel]" :value="i[KeyId]"></el-option>
        </template>
      </el-select>
    </template>
  </div>
</template>
<style lang="scss" >
.c-select {
  width: 100%;
  .el-select__tags {
    overflow: hidden;
  }
}
</style>
<script>
export default {
  props: {
    value: {},
    //常用控件/请假组件
    ComponentType: {
      type: Number,
      default: 0,
    },
    //常用控件:0-99:文本/多行文本/说明文字 100-199:数字/整数 200-299:日期/日期+上下午/日期+时分 300-399:单选/多选 400-499:附件
    //请假组件:请假类型/开始时间/结束时间/请假时长/销假状态/实际结束时间/开始时间部分/结束时间部分/实际结束时间部分
    ItemType: {
      type: Number,
      default: 0,
    },
    Options: {
      type: Array,
      default: () => [],
    },
    KeyId: {
      type: String,
      default: "LeaveTypeId",
    },
    KeyLabel: {
      type: String,
      default: "LeaveTypeName",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  computed: {
    show() {
      this.value1 = "";
      this.value2 = "";
      this.label = "";
      if (this.ComponentType == 0) {
        if (this.ItemType == 0) return "文本";
        if (this.ItemType == 1) return "多行文本";
        if (this.ItemType == 100) return "数字";
        if (this.ItemType == 101) return "整数";
        if (this.ItemType == 200) return "日期";
        if (this.ItemType == 201) return "日期+上下午";
        if (this.ItemType == 202) return "日期+时分";
        if (this.ItemType == 300) return "单选";
        if (this.ItemType == 301) return "多选";
        if (this.ItemType == 400) return "附件";
      } else {
        if (this.ItemType == 0) return "下拉框";
        if (this.ItemType == 1) return "日期+时分";
        if (this.ItemType == 2) return "日期+时分";
        if (this.ItemType == 3) return "数字";
        if (this.ItemType == 4) return "下拉框";
        if (this.ItemType == 5) return "日期+时分";
        if (this.ItemType == 6) return "日期+时分";
        if (this.ItemType == 7) return "日期+时分";
        if (this.ItemType == 8) return "日期+时分";
      }
      return "";
    },
  },
  watch: {
    value1(data) {
      // console.log("watch", data);
      // this.$emit("input", data);
      if (this.show == "下拉框") {
        if (this.multiple) {
          // this.$emit("input", data);
          // this.$emit("change1", data);
        } else {
          var item = this.Options.find((x) => x[this.KeyId] == data);
          if (item == undefined) {
            this.$emit("input", null);
            this.$emit("change1", null);
          } else {
            this.$emit("input", item[this.KeyId]);
            this.$emit("change1", item[this.KeyId]);
          }
        }
      } else {
        this.$emit("input", data);
        this.$emit("change1", data);
      }
    },
    value2(data) {
      this.$emit("change2", data);
    },
  },
  data() {
    return {
      value1: "",
      value2: "",
      label: "",
    };
  },
  methods: {
    init() {
      // console.log("init", this.value);
      if (this.show == "下拉框") {
        if (this.multiple) {
          this.value1 = this.value.length > 0 ? this.value.split(",") : [];
        }
      } else this.value1 = this.value;
    },
    onChange(e) {
      if (this.multiple) {
        this.$emit("input", e.join(","));
        this.$emit("change1", e.join(","));
      } else {
        // var item = this.Options.find((x) => x[this.KeyId] == data);
        // if (item == undefined) {
        //   this.$emit("input", null);
        //   this.$emit("change1", null);
        // } else {
        //   this.$emit("input", item[this.KeyId]);
        //   this.$emit("change1", item[this.KeyId]);
        // }
      }
    },
  },
};
</script>